/* tslint:disable */
/* eslint-disable */
/**
 * BackendFramework
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { GramCatGroup } from "./gram-cat-group";

/**
 *
 * @export
 * @interface GrammaticalInfo
 */
export interface GrammaticalInfo {
  /**
   *
   * @type {string}
   * @memberof GrammaticalInfo
   */
  grammaticalCategory: string;
  /**
   *
   * @type {GramCatGroup}
   * @memberof GrammaticalInfo
   */
  catGroup: GramCatGroup;
}
